type ReviewsToolbarProps = Record<string, never>;

export function ReviewsToolbar(_props: ReviewsToolbarProps) {
  return (
    <div className="mb-2 flex flex-col gap-4">
      <div className="flex flex-wrap items-center justify-between space-y-2">
        <div>
          <h2 className="font-bold text-2xl tracking-tight">
            ລາຍການຄຳເຫັນສິນຄ້າ
          </h2>
          <p className="text-muted-foreground">
            ຄວບຄຸມຄຳເຫັນສິນຄ້າ ຫຼື ລາຍວິຊາ
          </p>
        </div>
      </div>
    </div>
  );
}
